import React from 'react';
import { Link } from 'react-router-dom';
import SEO from '../components/SEO';
import '../styles/Legal.css';

const PrivacyPolicy = () => (
  <main className="legal-page">
    <SEO
      title="Privacy Policy | Bularis Tech"
      description="Read how Bularis Tech handles information submitted through its website and Contact form."
      path="/privacy-policy"
    />

    <header className="legal-hero">
      <div className="legal-container">
        <span className="legal-eyebrow">Legal</span>
        <h1>Privacy Policy</h1>
        <p>This policy explains how information may be collected and handled when you visit the Bularis Tech website or contact us about a project or service.</p>
        <p className="legal-date">Effective: August 31, 2026</p>
      </div>
    </header>

    <div className="legal-container legal-document">
      <section>
        <h2>Information you provide</h2>
        <p>When you use our Contact form or communicate with Bularis Tech, you may provide information such as your name, email address, message, and details about a project, business requirement, or technical problem. If you choose to include a phone number or other contact information in your message, that information may also be received.</p>
        <p>Please avoid sending passwords, payment credentials, or other sensitive information through the Contact form.</p>
      </section>

      <section>
        <h2>How information may be used</h2>
        <p>Information submitted through the website may be used to:</p>
        <ul>
          <li>Respond to questions, project inquiries, and requests for information.</li>
          <li>Understand the service, solution, product, or technical support you are asking about.</li>
          <li>Discuss and provide requested services or prepare for a potential client engagement.</li>
          <li>Maintain the reliability, security, and operation of the website and its communication systems.</li>
        </ul>
      </section>

      <section>
        <h2>Technical information and service logs</h2>
        <p>The website and the services used to operate it may process basic technical information, such as IP addresses, browser or device information, request timestamps, and error or security logs. This information may be used to deliver the website, diagnose problems, protect the service, and understand general website operation.</p>
      </section>

      <section>
        <h2>Service providers</h2>
        <p>Bularis Tech may rely on third-party providers for website hosting, cloud functions, email delivery, and other infrastructure needed to operate the website and respond to inquiries. Those providers may process information only as technically necessary to provide their services and are subject to their own terms and privacy practices.</p>
      </section>

      <section>
        <h2>Information handling and retention</h2>
        <p>Reasonable administrative and technical measures are used to protect information handled through the website. No internet transmission or storage system can be guaranteed to be completely secure.</p>
        <p>Inquiry information may be retained for as long as reasonably needed to respond, maintain relevant business records, address follow-up questions, or meet legitimate operational requirements. Information that is no longer reasonably required may be deleted or anonymized where practical.</p>
      </section>

      <section>
        <h2>External links</h2>
        <p>This website may link to third-party websites or services. Bularis Tech does not control their content or privacy practices, and this policy does not apply to information collected directly by those third parties.</p>
      </section>

      <section>
        <h2>Your privacy requests</h2>
        <p>You may contact Bularis Tech to ask about personal information you submitted through the website or to request a reasonable correction or deletion. Some information may need to be retained where reasonably necessary for security, recordkeeping, or legal purposes.</p>
      </section>

      <section>
        <h2>Policy updates</h2>
        <p>This policy may be updated as the website, services, or information-handling practices evolve. The effective date above will be revised when material updates are published.</p>
      </section>

      <section>
        <h2>Contact Bularis Tech</h2>
        <p>For a privacy question or request, use the <Link to="/contact">Bularis Tech Contact page</Link> and explain how we can help.</p>
      </section>
    </div>
  </main>
);

export default PrivacyPolicy;
